import { render } from "./UserSignature.vue?vue&type=template&id=3a751096&scoped=true"
import script from "./UserSignature.vue?vue&type=script&lang=js"
export * from "./UserSignature.vue?vue&type=script&lang=js"

import "./UserSignature.vue?vue&type=style&index=0&id=3a751096&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a751096"]])

export default __exports__